import React from "react";

const AppLanguageContext = React.createContext();

export const AppLanguageProvider = AppLanguageContext.Provider;
export const AppLanguageConsumer = AppLanguageContext.Consumer;

export default AppLanguageContext;
